// extracted by mini-css-extract-plugin
module.exports = {"loader":"Button_loader__iXF7p","load":"Button_load__2xIN6","button":"Button_button__81mzk"};